export default __webpack_public_path__ + "static/media/gallery-wip-handle_10.dba9e271.jpg";